import { formatWeight } from '@jane/bloom/utils/strings/formatWeight';

type WeightKeys =
  | 'price_each'
  | 'price_eighth_ounce'
  | 'price_gram'
  | 'price_half_gram'
  | 'price_half_ounce'
  | 'price_ounce'
  | 'price_quarter_ounce'
  | 'price_two_gram';

type DiscountWeightKeys =
  | 'discounted_price_each'
  | 'discounted_price_eighth_ounce'
  | 'discounted_price_gram'
  | 'discounted_price_half_gram'
  | 'discounted_price_half_ounce'
  | 'discounted_price_ounce'
  | 'discounted_price_quarter_ounce'
  | 'discounted_price_two_gram';

export const getWeightKey = (weight: string) =>
  (weight ? `price_${formatWeight(weight)}` : 'price_each') as WeightKeys;

export const getDiscountWeightKey = (weight: string) =>
  (weight
    ? `discounted_price_${formatWeight(weight)}`
    : 'discounted_price_each') as DiscountWeightKeys;
